import React from "react";
import { useLocation } from "react-router-dom";
import ErrorMessage from "../../../components/ErrorMessage/ErrorMessage";
import Button from "../../../components/Button/Button";

export type ErrorType =
  | "TECHNICAL_ERROR"
  | "FAILED_VERIFICATION_ERROR"
  | "EXPIRED_TOKEN";

export default function PasswordRenewError() {
  const { state } = useLocation();
  const errorType = state?.errorType as ErrorType;

  switch (errorType) {
    case "FAILED_VERIFICATION_ERROR":
      return <FailedVerificationError />;
    case "EXPIRED_TOKEN":
      return <ExpiredTokenError />;
    case "TECHNICAL_ERROR":
    default:
      return <TechnicalError />;
  }
}

const TechnicalError = () => (
  <ErrorMessage
    title="Neues Passwort"
    link={
      <Button as={"a"} href={"/login"} width={"fullWidthMobile"}>
        Zum Login
      </Button>
    }
  >
    <ErrorMessage.TechnicalError />
  </ErrorMessage>
);

const FailedVerificationError = () => (
  <ErrorMessage
    title="Neues Passwort"
    link={
      <Button as={"a"} href={"/login"} width={"fullWidthMobile"}>
        Zum Login
      </Button>
    }
  >
    <ErrorMessage.FailedVerificationError />
  </ErrorMessage>
);

const ExpiredTokenError = () => (
  <ErrorMessage
    title="Neues Passwort"
    link={
      <Button
        as={"a"}
        href="/login/passwort-vergessen-email/"
        width={"fullWidthMobile"}
        target="_self"
        rel="noreferrer"
      >
        Neuen Link anfordern
      </Button>
    }
  >
    <p>
      <strong>Dein persönlicher Link ist abgelaufen</strong>
    </p>
    <p>
      Leider ist dein persönlicher Link ungültig. Das kann daran liegen, dass er
      entweder älter als 24 Stunden und daher abgelaufen ist oder weil er
      bereits verwendet wurde.
    </p>
  </ErrorMessage>
);
